export default __webpack_public_path__ + "static/media/Queue Array Visual.e833bb2f.svg";